import React from 'react';
import { TeamMember } from '../model/TeamMember';
import DynamicTeamMemberImage from './DynamicTeamMemberImage';
import { StaticImage } from "gatsby-plugin-image";

interface TeamMemberProps {
  member: TeamMember;
}

export default function TeamMemberView(props: TeamMemberProps) {
  const { member } = props;
  return(
    <article className="is-flex columns is-align-items-flex-start">
      <div className="column is-flex is-justify-content-center teamImageContainer">
        {member.photo && (
          <DynamicTeamMemberImage filename={member.photo} alt={member.name} className="positionMember" />
        )}
        <div className="waves">
          <StaticImage
            src="../images/waves.svg"
            alt="waves"
          />
        </div>
      </div>
      <div className="column">
        <h1 className="memberName title is-3 is-spaced">{member.name}</h1>
        <br/>
        <span className="subtitle memberjob">{member.job}</span>
        <div className="is-size-6 has-text-justified" dangerouslySetInnerHTML={{__html: member.html}} />
      </div>
    </article>
  );
}
